module.exports = __webpack_public_path__ + "static/img/step-1.5c080cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/ChoosePhoto/img/step-1.svg
// module id = 445
// module chunks = 0